import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';


import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  View,
} from '@uncinc/react-drupal-core';
import {
  MultiSelect,
} from '../../../components';
import {
  getVocabulary,
} from '../../../store/actions/UI';

import './style.scss';

const ParagraphLatestStories = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [storyTypeFilter, setStoryTypeFilter] = useState([]);


  useEffect(() => { dispatch(getVocabulary('story_types')); }, [dispatch]);

  return (
    <div id={id} className="ParagraphLatestStories">

      {/* Start Filters */}
      <Container>
        <div className="row ParagraphLatestStories__filters">
          <div className="col-12 dropdown-holder">
            <div className="mb-1">
              <b>{t('filters.story_type.placeholder')}</b>
            </div>
            <MultiSelect
              setStoryTypeFilter={setStoryTypeFilter}
            />
          </div>
        </div>
      </Container>
      {/* End Filters */}

      {/* Start Content */}
      <View
        className="ParagraphLatestStories__view"
        page={currentPage}
        args={storyTypeFilter.length > 0 ? [storyTypeFilter.join('+')] : ['all']}
        id="latest_stories"
        setCurrentPage={setCurrentPage}
        display="block_1"
      />
      {/* End Content */}

    </div>
  );
};

export default ParagraphLatestStories;
